import React from 'react';
import { InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import { FilterOption } from '../utils/filter-options';

type ChangeHandler = (e: any) => void;

// Campo de texto/número dos filtros: Enter dispara a consulta
export function FilterInput({ label, name, value, type, onChange, onSearch }: {
    label: string; name: string; value?: string | number; type?: 'text' | 'number'; onChange: ChangeHandler; onSearch: () => void;
}) {
    return (
        <React.Fragment>
            <InputLabel>{label}</InputLabel>
            <OutlinedInput
                fullWidth
                name={name}
                type={type}
                value={value ?? ''}
                onChange={onChange}
                onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            />
        </React.Fragment>
    );
}

// Seleção dos filtros com a opção vazia ("Todos"/"Todas") no topo
export function FilterSelect({ label, name, value, options, emptyLabel = 'Todos', disabled, onChange }: {
    label: string; name: string; value?: string | number; options: FilterOption[]; emptyLabel?: string; disabled?: boolean; onChange: ChangeHandler;
}) {
    return (
        <React.Fragment>
            <InputLabel>{label}</InputLabel>
            <Select fullWidth name={name} value={value ?? ''} onChange={onChange} disabled={disabled}>
                <MenuItem value=""><em>{emptyLabel}</em></MenuItem>
                {options.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
            </Select>
        </React.Fragment>
    );
}
